/* 用export把方法暴露出来 */
import { apiUrl, appType } from '@/router/router.config'
import { MessageBox, Toast } from 'mint-ui'
import storeState from '@/store'
/*  swiper 选项卡函数 参数说明
 *       obj  必选，导航列表
 *       swiperObj: 必选，HTML元素或者string类型，Swiper容器的css选择器
 *       className: 必选，当前样式的类名
 *       effect：可选，切换效果，默认为"slide"，可设置为"fade，cube，coverflow，flip"。
 *       其他参数参阅官网 http://www.swiper.com.cn
 * */
let netToast;
let AppName;
let AppVersion;
let UUID;

/*时间格式化
 *yyyy-MM-dd hh:mm:ss.S
 */
export function formatDate(date, fmt) {

	if (typeof (date) === 'string') {
		//部分移动端【小米、vivo等】在 new Date('2018-01-01T16:49:00')时会自动加上时区值【UTC/GMT+08:00】
		//iOS 时间格式化不兼容 new Date('2018-01-01T16:49:00') 
		date = date.replace(/T/g, ' ').replace(/-/g, "/").replace(/\.[\d]{3}Z/, '');
		date = new Date(date);
	}

	var t = {
		"M+": date.getMonth() + 1,
		"d+": date.getDate(),
		"h+": date.getHours(),
		"m+": date.getMinutes(),
		"s+": date.getSeconds(),
		"q+": Math.floor((date.getMonth() + 3) / 3), //quarter
		"S": date.getMilliseconds()
	};
	if (/(y+)/.test(fmt)) {
		fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
	}
	for (var i in t) {
		if (new RegExp("(" + i + ")").test(fmt)) {
			fmt = fmt.replace(RegExp.$1, RegExp.$1.length == 1 ? t[i] : ("00" + t[i]).substr(("" + t[i]).length));
		}
	}

	return fmt;

};

/**获取某月最后一天
 * @return 某月最后一天
 * @param {Object} year
 * @param {Object} month
 */
export function getDaysInMonth(year, month) {
	var dt = new Date(year, month, 0);
	//console.log(dt.getFullYear()+"年"+(dt.getMonth()+1)+"月"+dt.getDate()+"日");
	//console.log(dt.format("yyyy-MM-dd"));
	return dt.getDate();
}

//判断登录
export function confirmLogin(FromUrl, ToUrl, LevelType, t1) {
	if (!UUID && !AppName && !AppName && currentEnvironment()) {
		if (window.plus) {
			plusReady();
		} else {
			document.addEventListener('plusready', plusReady, false);
		}

		function plusReady() {
			plus.runtime.getProperty(plus.runtime.appid, function (wgtinfo) {
				UUID = plus.device.uuid; //移动设备的唯一标识号。
				AppName = wgtinfo.name; //app名字
				AppVersion = wgtinfo.version; //APP版本
				saveLog(FromUrl, ToUrl, 'trace', t1);
			});
		};
	} else {
		saveLog(FromUrl, ToUrl, LevelType, t1);
	}

}
export function saveLog(FromUrl, ToUrl, LevelType, t1) {
	var Level = 'debug';
	if (LevelType) {
		Level = LevelType;
	}
	var json = {
		"LoginStatus": true, //true去判断有没有登录，false，不去判断登录
		"Token": store.get('user') ? store.get('user').token : "",
		"UserID": store.get('user') ? store.get('user').user_id : "", //移动设备的唯一标识号。
		"UUID": UUID ? UUID : "",
		"AppName": AppName ? AppName : "", //app名字
		"AppVersion": AppVersion ? AppVersion : "", //APP版本
		"Page": FromUrl, //上一个页面
		"Address": ToUrl, //这个当前页面
		"StartTime": formatDate(t1, 'yyyy-MM-dd hh:mm:ss.S'),
		"EndTime": formatDate(new Date(), 'yyyy-MM-dd hh:mm:ss.S'),
		"LogLevel": Level,
		"Note": ""  //ex
	}
	if (store.get('user') && store.get('user').token) {
		$.ajax({
			type: 'POST',
			url: apiUrl() + '/alive',
			dataType: "json",
			contentType: 'application/json',
			data: JSON.stringify(json),
			success: function (data, status) {
				if (data.state != 'SUCCESS') {
					Toast({
						message: data.info,
						position: 'center',
						duration: 2000
					});
					setTimeout(function () {
						window.location.href = '/page/login';
					}, 1500);
				}
			}
		});
	} else {
		window.location.href = '/page/login'
	}
}
//用户登出
export function loginOut(elem) {
	MessageBox.confirm('', {
		message: '确定退出登录?',
		title: '提醒',
		confirmButtonText: '是',
		cancelButtonText: '否'
	}).then(action => {
		if (action == 'confirm') {
			var token = store.get('user') ? store.get('user').token : "";
			if (token.length > 10) {
				$.ajax({
					type: 'POST',
					url: apiUrl() + '/expire?token=' + token,
					dataType: 'json',
					success: function (data) {
						//console.log(url + '/expire?token=' + token);
						//成功则清除数据返回登录页面
						if (data.state == 'SUCCESS') {
							store.remove('user');
							storeState.commit({
								type: "setState",
								attr: 'oTaskReleaseContent',
								value: {
									oTaskType: '',
									oTRcompany: '',
									oTaskname: '',
									oTRarchiveArr: '',
									oTRarchiveItemArr: '',
									oTRImages: [],
									oTRtime: '',
									oTRcontent: '',
									projecter:''
								}
							});
							storeState.commit({
								type: "setState",
								attr: 'companyInfo',
								value: '',
								storeFlag: 1
							});
							if(typeof(layer)!='undefined'&&layer){
								layer.closeAll();
							}
							elem.$router.push('/login');
							if(typeof(stopConnect)!='undefined'&&stopConnect){stopConnect();}
						} else {
							document.addEventListener('plusready', function () {
								plus.nativeUI.toast('服务器连接失败', {
									verticalAlign: "center"
								});
							});
						}
					},
					error: function () {
						document.addEventListener('plusready', function () {
							plus.nativeUI.toast('网络连接失败', {
								verticalAlign: "center"
							});
						});
					}
				});
			}
		}
	}).catch(err => {
		if (err != 'cancel') {
			console.log(err);
		}
	});
}

/**拨号
 * 号码及提示内容处理
 * */
export function dial(phone, title, message) {
	var _phone, _title, _msg;
	if (phone) {
		_phone = phone;
	} else {
		switch (appType()) {
			case 2:
				_phone = '0755-82880789';
				break; // 2 华网电力
			case 4:
				_phone = '400-006-1891';
				break; // 4 电安电力
			case 7:
				_phone = '0769-83300801';
				break; // 7 东开智维 
			case 9:
				_phone = '0769-83300022';
				break; // 9 智慧梅兰
			case 11:
				_phone = '0750-6206699';
				break; // 11 大光明
			case 12:
				_phone = '0851-84867374';
				break; // 12 贵州新电能
			case 13:
				_phone = '0775-4862966';
				break; // 13 超源电力
			default:
				_phone = '0755-89207901';
				break; // 0 默认全量通 量子力
		}
	}
	_title = title ? title : '';
	_msg = message ? message : '';
	dialing(_phone, _title, _msg);
}

/**拨打电话
 * @param {Object} 电话号码
 * @param {Object} 提示标题
 * @param {Object} 提示内容
 * */
export function dialing(phone_number, title, message) {

	console.log('电话:' + phone_number + ',标题:' + title + ',提示内容:' + message);

	if (window.plus) {
		plusReady();
	} else {
		document.addEventListener("plusready", plusReady, false);
	}

	function plusReady() {
		if (message) { //有提示内容的才弹确认框
			plus.nativeUI.confirm(message,
				function (event) {
					if (event.index == 1) {
						plus.device.dial(phone_number, false);
					} else {
						return false;
					}
				}, title, ['取消', '确定']
			)
		} else {
			console.log('直接呼叫:' + phone_number);
			plus.device.dial(phone_number, false);
		}

	}
}

/*
 * toFixed
 * 字符串转浮点数
 * @param {Object} str字符串
 * @param {Object} len小数位
 * @param {Object} flag是否强制小数位
 */
export function toFixed(str, len, flag) {
	var result;
	try {
		if (typeof (str) === 'number') {
			result = parseFloat(parseFloat(str).toFixed(len)); //去除转化后，小数点后多余的零
		} else {
			//当目标为整数时，默认小数位为0
			len = str.indexOf('.') > -1 ? len : 0;
			if (len > 0 && !flag) {
				len = parseInt(str.split('.')[1]) == 0 ? 0 : len;
			}
			result = parseFloat(parseFloat(str).toFixed(len)); //去除转化后，小数点后多余的零
		}
		result = result == 0 ? 0 : result == -1 ? "-" : result;
	} catch (e) {
		result = "-";
	}
	return result;
};
/**
 *手机端秒内点击两次back键退出本程序
    flag:判断是否退出程序，
 that：传过来的this
 url：返回的上一个页面的url
 */
// console.log(layer)
export function applicationExit(flag, that, url, fun) {
	function indexBack() {
		if ($('.layui-m-layer').length == 1 && $('.layui-m-layer:first .layui-m-layermain').css('display') == 'block') {
			$('.layui-m-layer:first .layui-m-layermain').hide();
		} else if ($('.layui-m-layer').length > 1) {
			var layero = $('.layui-m-layer:last')
				, index = layero.attr('index')
				, PANEL = '.layim-panel';
			setTimeout(function () {
				layer.close(index);
			}, 300);
			$('.layui-m-layer:last').find(PANEL).eq(0).removeClass('layui-m-anim-left').addClass('layui-m-anim-rout');
			layero.prev().find(PANEL).eq(0).removeClass('layui-m-anim-lout').addClass('layui-m-anim-right');
		} else {
			if (!first) {
				//获取时间
				first = (new Date()).getTime();
				plus.nativeUI.toast('再按一次退出程序', {
					verticalAlign: "center"
				});
				setTimeout(function () {
					first = null;
				}, 1000);
			} else {
				if (new Date().getTime() - first < 1000) {
					plus.runtime.quit();
				}
			}
		}
	}

	function urlBack() {
		if ($('.layui-m-layer').length == 1 && $('.layui-m-layer:first .layui-m-layermain').css('display') == 'block') {
			$('.layui-m-layer:first .layui-m-layermain').hide();
		} else if ($('.layui-m-layer').length > 1) {
			var layero = $('.layui-m-layer:last')
				, index = layero.attr('index')
				, PANEL = '.layim-panel';
			setTimeout(function () {
				layer.close(index);
			}, 300);
			$('.layui-m-layer:last').find(PANEL).eq(0).removeClass('layui-m-anim-left').addClass('layui-m-anim-rout');
			layero.prev().find(PANEL).eq(0).removeClass('layui-m-anim-lout').addClass('layui-m-anim-right');
		} else {
			that.$router.push(url);
		}
	}

	function GoBack() {
		if ($('.layui-m-layer').length == 1 && $('.layui-m-layer:first .layui-m-layermain').css('display') == 'block') {
			$('.layui-m-layer:first .layui-m-layermain').hide();
		} else if ($('.layui-m-layer').length > 1) {
			var layero = $('.layui-m-layer:last')
				, index = layero.attr('index')
				, PANEL = '.layim-panel';
			setTimeout(function () {
				layer.close(index);
			}, 300);
			$('.layui-m-layer:last').find(PANEL).eq(0).removeClass('layui-m-anim-left').addClass('layui-m-anim-rout');
			layero.prev().find(PANEL).eq(0).removeClass('layui-m-anim-lout').addClass('layui-m-anim-right');
		} else {
			that.$router.go(-1);
		}
	}
	var first = null;
	plus.key.removeEventListener("backbutton", indexBack);
	plus.key.removeEventListener("backbutton", urlBack);
	plus.key.removeEventListener("backbutton", GoBack);
	if (flag == 1) {
		plus.key.addEventListener('backbutton', indexBack, false);
	} else if (url) {
		plus.key.addEventListener('backbutton', urlBack, false);
	} else if (fun) {
		plus.key.addEventListener('backbutton', fun, false);
	} else {
		plus.key.addEventListener('backbutton', GoBack, false);
	}
	document.addEventListener("netchange", wainshow, false);

	function wainshow() {
		if (plus.networkinfo.getCurrentType() == plus.networkinfo.CONNECTION_NONE) {
			if (!netToast) {
				netToast = Toast({
					message: '网络连接失败,请检查网络',
					position: 'center',
					duration: -1,
					className: 'netToast'
				});
			}
		} else {
			netToast.close();
			netToast = '';
		}
	}
}
/**
 * 电力工程服务==筛选根据id筛选指定id的数据
 * @param {Object} array:遍历该数组
 * @param {Object} id:根据此id筛选
 * @param {Object} tag：标记
 */
export function filterData(array, id, tag) {
	var resultArray = [];
	if (array) {

		for (var i = 0, len = array.length; i < len; i++) {
			if (tag == 'id') {
				if (array[i].id == id) {
					resultArray.push(array[i]);
				}
			} else if (tag == 'pid') {
				if (array[i].pid == id) {
					resultArray.push(array[i]);
				}
			} else if (tag == 'cid') {
				if (array[i].cid == id) {
					resultArray.push(array[i]);
				}
			} else if (tag == 'typeid') {
				if (array[i].typeid == id) {
					resultArray.push(array[i]);
				}
			}
		}
	}
	return resultArray;
}
/**
 * 检测当前环境,
 * @return PC端(false)/手机端(true)
 */
export function currentEnvironment() {
	var sys = {
		win: false,
		mac: false,
		xll: false
	};
	var flag = true;
	var p = navigator.platform; //检测平台
	sys.win = p.indexOf("Win") == 0;
	sys.mac = p.indexOf("Mac") == 0;
	sys.x11 = (p == "X11") || (p.indexOf("Linux") == 0);
	if (sys.win || sys.mac || sys.xll) {
		flag = false; /*PC端返回false*/
	}
	return flag;
}

//清除缓存
export function clearCache() {
	mui.plusReady(function () {
		clearDownload(); //清除安装包
		clearStorage(); //
		plus.push.clear(); //清空推送消息
		plus.nativeUI.toast('清除成功', {
			verticalAlign: "center"
		});
	});
}

//清除手机端update目录下文件
export function clearDownload() {
	//打开_doc/update
	plus.io.requestFileSystem(plus.io.PRIVATE_DOC, function (fs) {
		fs.root.getDirectory('update', {}, function (entry) {
			//递归删除update目录
			entry.removeRecursively(function (entry) { });
		}, function (e) { })
	}, function (e) { });
}

//清除浏览器Storage缓存
export function clearStorage() {
	
	plus.navigator.removeAllCookie(); //清除应用所有cookie
	sessionStorage.clear(); //清除所有sessionStorage内容
	var user = store.get("user");
	var username = store.get("username");
	localStorage.clear();
	store.set('user', user);
	store.set('username', username);
	store.forEach(function (key, val) {
		if ((key.indexOf('data_') > -1) || (key.indexOf('fen') > -1)) {
			store.remove(key);
		}
	});
}

/**
 * 设置状态栏样式
 * */
export function BarStyle(backcolor) {
	var color = backcolor ? backcolor : "#0c172b";
	//ios设置通知栏背景色
	function plusReady() {
		plus.navigator.setFullscreen(false);
		//设置系统状态栏背景颜色
		plus.navigator.setStatusBarBackground(color);
		// 设置系统状态栏文字为白色
		plus.navigator.setStatusBarStyle("UIStatusBarStyleBlackOpaque");
		plus.navigator.closeSplashscreen();
	}
	if (window.plus) {
		plusReady();
	} else {
		document.addEventListener("plusready", plusReady, false);
	}

}
/**
 * [顺时针方向画图，起始点在左侧]
 * @param  {[number]} percent [所占的进度百分比，比如66%，则传66即可，0 <= percent <= 100]
 * @param  {[number]} sR      [圆弧起始角度，可不传，默认是π/2，Math.PI/2 <= sR < 3/2 * Math.PI]
 */
export function draw(remWidth, percent, sR, dom, baseColor, coverColor, borderPercent) {
	if (percent < 0 || percent > 100) {
		percent = 100;
	}
	if (sR < Math.PI / 2 || sR >= 3 / 2 * Math.PI) {
		return;
	}
	var canvas = dom, clientWidth = document.documentElement.clientWidth;
	//根据设计图中的canvas画布的占比进行设置
	if (clientWidth > 720) { clientWidth = 720 };
	var canvasWidth = Math.floor(clientWidth * remWidth / 720);
	canvas.setAttribute('width', canvasWidth + 'px');
	canvas.setAttribute('height', canvasWidth + 'px');
	var cxt = canvas.getContext('2d'),
		cWidth = canvas.width,
		cHeight = canvas.height,
		baseColor = baseColor,
		PI = Math.PI,
		sR = sR || 1 / 2 * PI; // 默认圆弧的起始点弧度为π/2
	if (coverColor.constructor == Array) {
		var g = cxt.createLinearGradient(0, 0, 180, 0); //创建渐变对象  渐变开始点和渐变结束点
		g.addColorStop(0, '#e82d72'); //添加颜色点
		g.addColorStop(1, '#44e1ce'); //添加颜色点
	} else {
		var g = coverColor;
	}
	var finalRadian = sR + ((PI + (PI - sR) * 2) * percent / 100); // 红圈的终点弧度
	var step = (PI + (PI - sR) * 2) / 100; // 一个1%对应的弧度大小
	var text = 0; // 显示的数字
	var borderWidth = borderPercent * cWidth;
	var r = cWidth / 2 - borderWidth;
	var timer = setInterval(function () {
		cxt.clearRect(0, 0, cWidth, cHeight);
		var endRadian = sR + text * step;

		if (endRadian.toFixed(2) >= finalRadian.toFixed(2)) {
			clearInterval(timer);
		}
		// 画灰色圆弧
		drawCanvas(cWidth / 2, cHeight / 2, r, sR, sR + (PI + (PI - sR) * 2) + step, baseColor, borderWidth / 2);
		// 画红色圆弧
		drawCanvas(cWidth / 2, cHeight / 2, r, sR, endRadian, g, borderWidth);
		text++;
	}, 5);

	function drawCanvas(x, y, r, sRadian, eRadian, color, lineWidth) {
		cxt.beginPath();
		cxt.lineCap = "round";
		cxt.strokeStyle = color;
		cxt.lineWidth = lineWidth;
		cxt.arc(x, y, r, sRadian, eRadian, false);
		cxt.stroke();
	}
}
// 手指缩放
export function setGesture(el){
    var obj={}; //定义一个对象
    var istouch=false;
    var start=[],scale=0;
    el.addEventListener("touchstart",function(e){
        if(e.touches.length>=2){  //判断是否有两个点在屏幕上
            istouch=true;
            start=e.touches;  //得到第一组两个点
            obj.gesturestart&&obj.gesturestart.call(el); //执行gesturestart方法
        };
    },false);
    document.addEventListener("touchmove",function(e){
        if(e.touches.length>=2&&istouch){
			e.preventDefault();
            var now=e.touches;  //得到第二组两个点
            scale=getDistance(now[0],now[1])/getDistance(start[0],start[1]); //得到缩放比例，getDistance是勾股定理的一个方法
            obj.gesturemove&&obj.gesturemove.call(el,e);  //执行gesturemove方法
        };
    },false);
    document.addEventListener("touchend",function(e){
        if(istouch&&scale!=0){
            istouch=false;
            obj.gestureend&&obj.gestureend.call(el,scale);  //执行gestureend方法
        };
    },false);
    return obj;
};
function getDistance(p1, p2) {
    var x = p2.pageX - p1.pageX,
        y = p2.pageY - p1.pageY;
    return Math.sqrt((x * x) + (y * y));
};


// WEBPACK FOOTER //
// ./src/assets/js/common.js